module.exports = __webpack_public_path__ + "static/img/Timely Support.833037d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Timely Support.png
// module id = Hsj9
// module chunks = 1